import { HttpClient } from '@angular/common/http';

import { APIWrapperBase } from '../../../api.wrapper.base';
import { APIAssignPolicyManager } from './api.policy.assign';
import { APICreatePolicyManager } from './api.policy.create';
import { APIListPolicyManager } from './api.policy.list';
import { APIListPolicyDeviceManager } from './api.policy.listDevice';
import { APIListPolicyGroupManager } from './api.policy.listGroup';
import { APIRemovePolicyManager } from './api.policy.remove';
import { APIUpdatePolicyManager } from './api.policy.update';
import { APIGetPolicyUsageManager } from './api.policy.usage.get';

export class APIPolicyWrapper extends APIWrapperBase {
    CreatePolicy: APICreatePolicyManager;
    ListPolicy: APIListPolicyManager;
    ListDeviceGroupInPolicy: APIListPolicyGroupManager;
    ListDeviceInPolicy: APIListPolicyDeviceManager;
    UpdatePolicy: APIUpdatePolicyManager;
    RemovePolicy: APIRemovePolicyManager;
    AssignPolicy: APIAssignPolicyManager;
    GetPolicyUsage: APIGetPolicyUsageManager;

    constructor(private http: HttpClient) {
        super();

        this.CreatePolicy = new APICreatePolicyManager(http);
        this.ListPolicy = new APIListPolicyManager(http);
        this.ListDeviceGroupInPolicy = new APIListPolicyGroupManager(http);
        this.ListDeviceInPolicy = new APIListPolicyDeviceManager(http);
        this.UpdatePolicy = new APIUpdatePolicyManager(http);
        this.RemovePolicy = new APIRemovePolicyManager(http);
        this.AssignPolicy = new APIAssignPolicyManager(http);
        this.GetPolicyUsage = new APIGetPolicyUsageManager(http);
    }

    public resetServerConfig(protocol: string, baseUrl: string, port: number): void {
        let targets = [
            this.CreatePolicy,
            this.ListPolicy,
            this.ListDeviceGroupInPolicy,
            this.ListDeviceInPolicy,
            this.UpdatePolicy,
            this.RemovePolicy,
            this.AssignPolicy,
            this.GetPolicyUsage
        ];

        targets.forEach(t => t.resetServerConfig(protocol, baseUrl, port));
    }
}